<p-menu appendTo="body" #menu [model]="items" [popup]="popup" />
<ms-button [class]="class" variant="text" (click)="menu.toggle($event)" [icon]="icon" />
